import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToasterService } from '@services/toaster.service';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { LeaveCommentsResponse } from '@interfaces/vendor-management-model';
import { TIMESHEET_CONSTANTS } from '../ops-timesheet/ops-timesheet.constants';

@Injectable({
  providedIn: 'root',
})
export class TimesheetCalendarService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToasterService,
  ) {}

  getEmployeeTimesheet(
    month: number,
    year: number,
  ): Observable<LeaveCommentsResponse> {
    let params = new HttpParams()
      .set('month', month.toString())
      .set('year', year.toString());

    return this.http
      .get<LeaveCommentsResponse>(`${this.baseUrl}${TIMESHEET_CONSTANTS.API_ENDPOINTS.HIRING_LEAVE_COMMENTS}`, { params })
      .pipe(
        catchError((error) => {
          this.toasterService.showError(TIMESHEET_CONSTANTS.MESSAGES.FAILED_LOAD_TIMESHEET, TIMESHEET_CONSTANTS.TITLES.LOAD_ERROR);
          return throwError(() => error);
        }),
      );
  }
}
